import styled from "styled-components";

import { StyledP } from "./atoms/text";
import { HeaderLogo } from "./atoms/logoImages";
import { signitures, paragraphs } from "../utils/messageText";
import logo from "../utils/img/kuf3.png";
import { lightGray, white } from "../utils/color";
import { Fragment } from "react";
import { Header, Title } from "./atoms/titles";

const MessageContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	font-family: "Noto Sans KR", sans-serif;
	width: 100%;
	padding: 15px 25px;
	padding-bottom: 100px;
	box-sizing: border-box;
	background-color: ${lightGray};
`;

const KUF = styled.img`
	width: 150px;
	margin: 20px 20px 0 20px;
`;

const Signiture = styled.p`
	margin: 5px;
	font-size: 14px;
	font-weight: 500;
	text-align: right;
`;

const GreetingContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Greeting = styled.p`
	font-size: 18px;
	font-weight: 500;
`;

export default function Message() {
	return (
		<Fragment>
			<Header>
				<HeaderLogo src={logo} />
			</Header>
			<MessageContainer>
				<Title color={white}>인사말</Title>
				<GreetingContainer>
					<Greeting>국내 최대 도시포럼에 귀하를 초대합니다.</Greeting>
				</GreetingContainer>
				{paragraphs.map((para, i) => (
					<StyledP key={`p${i}`}>
						{para} <br />
					</StyledP>
				))}
				<StyledP />
				{signitures.map((s, i) => (
					<Signiture key={`signiture${i}`}>{s}</Signiture>
				))}
			</MessageContainer>
		</Fragment>
	);
}
